import React, { useEffect, useState } from 'react';
import { QuestionRendererProps } from './types';
import { Input } from '../../ui/Input'; // Assuming Input component exists or use standard input
import { LatexRenderer } from '../../ui/LatexRenderer';
export function FillInRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  const [value, setValue] = useState('');
  const config = question.interactiveConfig || {};
  const placeholder = config.placeholder || 'Typ je antwoord...';
  const inputType = config.inputType || 'text'; // 'text' or 'number'
  const unit = config.unit || '';
  useEffect(() => {
    onReadyChange?.(value.trim().length > 0);
  }, [value, onReadyChange]);
  useEffect(() => {
    if (shouldValidate) {
      onAnswer(value);
    }
  }, [shouldValidate, value, onAnswer]);
  return <div className="w-full max-w-md mx-auto" data-id="element-1449">
      <div className="flex items-center gap-3" data-id="element-1450">
        <input type={inputType === 'number' ? 'number' : 'text'} value={value} onChange={e => setValue(e.target.value)} placeholder={placeholder} className="flex-1 p-4 text-lg border-2 border-slate-200 rounded-xl focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 outline-none transition-all" autoFocus data-id="element-1451" />
        {unit && <span className="text-lg font-bold text-slate-500" data-id="element-1452">
            <LatexRenderer content={unit} data-id="element-1453" />
          </span>}
      </div>
      <p className="text-sm text-slate-400 mt-2 text-center" data-id="element-1454">
        Druk op Enter om te controleren
      </p>
    </div>;
}